module.exports = __webpack_public_path__ + "static/luisjuarros-7f3072b9d02b3418020080b5ae3de419.jpg";